import { Injectable } from '@angular/core';
import { SnackTheme } from '@main/snackbar/const';
import { SnackbarFacade } from '@main/snackbar/data-access';
import {
  MyAccountActions,
  MyAccountSelectors,
  OrderDocumentApiService,
  StateWithMyAccount,
} from '@my-account/data-access';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatLatestFrom } from '@ngrx/operators';
import { Store } from '@ngrx/store';
import { CustomUserActions } from '@user/data-access';
import { Observable, of } from 'rxjs';
import { catchError, filter, map, switchMap } from 'rxjs/operators';

@Injectable()
export class OrderDocumentEffects {
  searchOrderDocument$: Observable<
    MyAccountActions.SearchOrderDocumentSuccess | MyAccountActions.SearchOrderDocumentFail
  > = createEffect(() =>
    this.actions$.pipe(
      ofType<MyAccountActions.SearchOrderDocument>(MyAccountActions.SEARCH_ORDER_DOCUMENT),
      switchMap((action) => {
        return this.orderDocumentApiService.search(action.payload).pipe(
          map((response) => new MyAccountActions.SearchOrderDocumentSuccess({ ...response, params: action.payload })),
          catchError(() => {
            this.snackbarFacade.setSnack({
              theme: SnackTheme.Yellow,
              title: 'Ошибка',
              text: 'При загрузке данных произошла ошибка, повторите попытку позже, или обратитесь к вашему менеджеру',
            });

            return of(new MyAccountActions.SearchOrderDocumentFail());
          }),
        );
      }),
    ),
  );

  resetSearchResultOnChangeLegalStatus$: Observable<MyAccountActions.SearchOrderDocumentReset> = createEffect(() =>
    this.actions$.pipe(
      ofType<CustomUserActions.SetLegalEntityStatus>(CustomUserActions.SET_LEGAL_ENTITY_STATUS),
      concatLatestFrom(() => this.store.select(MyAccountSelectors.getSearchOrderDocumentValue)),
      filter(([action, searchValue]) => !action.payload && Boolean(searchValue)),
      map(() => new MyAccountActions.SearchOrderDocumentReset()),
    ),
  );

  constructor(
    private actions$: Actions,
    private orderDocumentApiService: OrderDocumentApiService,
    private snackbarFacade: SnackbarFacade,
    private store: Store<StateWithMyAccount>,
  ) {}
}
